module.exports = __webpack_public_path__ + "static/pt2020-10ccf36e7e6cda002bfae1e6258f5fb1.svg";